module.exports = __webpack_public_path__ + "static/media/image.e36dc5f4.jpg";